import React, { createContext, useContext, useEffect, useLayoutEffect, useState, useRef } from 'react';
import { useMatch } from 'react-router-dom';
import { useApiContext } from '../context/ApiContext.jsx';

export const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
	const match = useMatch("/trivia/:sessionId");
	const { api, setAuthAccessors } = useApiContext();

	const [sessionId, setSessionId] = useState(match?.params?.sessionId);
	const [mockSession, setMockSession] = useState(null);
	const [token, setToken] = useState(null);

	const tokenRef = useRef(token);

	useEffect(() => {
		tokenRef.current = token;
	}, [token]);

	// Abilita refresh 401 SOLO nel Game, registrando gli accessors in ApiContext
	useEffect(() => {
		setAuthAccessors({
			getRefreshToken: () => tokenRef.current?.refresh_token,
			onTokenRefreshed: (newToken) => {
				setToken(newToken);
				setSessionId(newToken.session_id);
			}
		});

		return () => {
			setAuthAccessors({
				getRefreshToken: null,
				onTokenRefreshed: null
			});
		};
	}, [setAuthAccessors]);

	useEffect(() => {
		if (!sessionId) {
			localStorage.removeItem("session_id");
			return;
		}

		localStorage.setItem("session_id", sessionId);
	}, [sessionId]);

	useEffect(() => {
		if (!sessionId) return;
		const currentUrlSessionId = match?.params?.sessionId;
		if (sessionId !== currentUrlSessionId) {
			// aggiorna l’URL senza ricaricare la pagina
			window.history.replaceState(
				{},
				"",
				`/trivia/${sessionId}${window.location.search}${window.location.hash}`
			);
		}
	}, [sessionId]);

	useLayoutEffect(() => {
		const body = new URLSearchParams();
		body.append("sessionId", sessionId);

		api.post("/api/auth/token", body.toString(), {
			headers: {
				"Content-Type": "application/x-www-form-urlencoded"
			}
		}).then(res => {
			setToken(res.data);
			setSessionId(res.data.session_id);
		}).catch((err) => {
			// handled by ApiContext interceptor
			//console.error(err);
			//return Promise.reject(err);
		});
	}, []);

	return (
		<AppContext.Provider
			value={{
				sessionId,
				token,
				api
			}}
		>
			{children}
		</AppContext.Provider>
	);
};

export const useAppContext = () => {
	const ctx = useContext(AppContext);
	if (!ctx) throw new Error('useAppContext must be used within <AppProvider />');
	return ctx;
};